import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import useResponsive from 'ahooks/es/useResponsive';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';

import FontAwesomeIcon from '#/components/FontAwesomeIcon';
import ExploreEventsListing from '@/components/_events/ExploreEventsListing.tsx';
import ExplorePage from '@/components/_explore/ExplorePage.tsx';
import InfoCard from '@/components/_status/InfoCard';
import LinkButton from '@/components/LinkButton';
import { ExploreLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import PageDisabled from '@/components/PageDisabled.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';

const Meetups = () => {
  const featuresReady = useFlagsStatus().flagsReady;
  const enableExplore = useFlag('explore');
  const { xl } = useResponsive();
  const { t } = useTranslation(['common', 'event']);

  useTranslation(['event']);

  if (!featuresReady) {
    return <PageLoading />;
  }
  if (!enableExplore) {
    return <PageDisabled absolutelyCentered />;
  }

  return (
    <ExplorePage
      isSubPage
      title="explore:community_meetups"
      rightHeaderContent={
        <LinkButton
          to="/explore/meetups"
          className={clsx('ml-auto d-inline mr-0')}
          variant="info"
          size={xl ? 'xl' : undefined}
        >
          {t('event:button.official_meetups')}
          <FontAwesomeIcon icon={faChevronRight} size="lg" className="mx-0 ms-2" />
        </LinkButton>
      }
    >
      <InfoCard bgOverride="bg-light">
        <Trans
          ns="event"
          i18nKey="banner.community_meetups_info"
          components={{ strong: <strong /> }}
        />
      </InfoCard>
      <ExploreEventsListing types={['communitymeetup']} />
    </ExplorePage>
  );
};

export const Route = createFileRoute('/explore/community-meetups')({
  component: () => (
    <ExploreLayout title="explore:community_meetups">
      <Meetups />
    </ExploreLayout>
  ),
});
